import React from 'react';

import { Button, Modal } from '@attentive-platform/stem-ui';

const RemoveMemberModal = ({ show, onClose, onConfirm, loading }) => {
  return (
    <Modal
      show={show}
      heading='Remove this team member'
      onClose={onClose}
      content={
        <div className='flex flex-col gap-2 m-3 w-[360px]'>
          <div className='flex items-start gap-3'>
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' className='shrink-0 mt-0.5'>
              <circle cx='12' cy='12' r='10' fill='#faad14' />
              <path d='M12 7v6M12 16h.01' stroke='#fff' strokeWidth='2' strokeLinecap='round' />
            </svg>
            <div>
              <p className='text-base font-medium text-gray-900'>Remove this team member</p>
              <p className='text-sm text-gray-500 mt-1'>
                Their data will be transferred to the next teammate. This action cannot be undone.
              </p>
            </div>
          </div>
          <div className='flex justify-end gap-2 mt-4'>
            <Button size='medium' variant='outlined' onClick={onClose}>
              Cancel
            </Button>
            <Button color='primary' size='medium' onClick={onConfirm} loading={loading}>
              Remove
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default RemoveMemberModal;
